<template>
    <div v-if="gallery" class="mt-10">
      <Splide :has-track="false" class="-mx-4 md:mx-0 md:rounded-3xl" :options="options" @splide:moved="onSlideChange">
         <SplideTrack>
                <SplideSlide :key="item.id" v-for="item in gallery">
                  <picture
                    class="w-full select-none"
                    width="480"
                    height="600"
                    v-if="item.url"
                  >
                    <source
                      :srcset="`
                        ${item.url}?tr=w-480,h-480,
                        ${item.url}?tr=w-960,h-960 2x
                      `"
                      media="(max-width:480px)"
                    />
                    <source
                      :srcset="`
                        ${item.url}?tr=w-480,h-600,
                        ${item.url}?tr=w-960,h-1200 2x
                      `"
                      media="(min-width:1000px)"
                    />
                    <img class="md:h-[768px] w-full h-full object-cover aspect-square md:rounded-3xl" :src="`${item.url}?tr=w-240,h-300`" :alt="`${item.alt} image`">
                  </picture>
                </SplideSlide>
            </SplideTrack>

            <div class="flex flex-wrap items-start justify-between gap-4 px-4 2xl:px-0 mt-4">
              <figcaption v-if="currentCaption" class="caption text-md text-black font-normal flex-1 min-w-0">
                <p>{{ currentCaption }}</p>
                <br>
              </figcaption>
              
              <div v-else class="flex-1"></div>
              
              <div class="splide__arrows hidden md:flex gap-2 flex-shrink-0">
                <button class="splide__arrow--prev w-11 h-11 flex justify-center items-center bg-primary hover:bg-primary-tone rounded-full">
                    <svg class="relative -left-px" width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.22748 8.80219L2.37798 15.6517C1.94989 16.1155 1.20072 16.1155 0.772631 15.6517C0.308863 15.2236 0.308863 14.4744 0.772631 14.0463L6.80162 7.98167L0.772631 1.95269C0.308863 1.5246 0.308863 0.775431 0.772631 0.347338C1.20072 -0.11643 1.94989 -0.11643 2.37798 0.347338L9.22748 7.19684C9.69125 7.62493 9.69125 8.37409 9.22748 8.80219Z" fill="#3B3C4A"/>
                    </svg>
                </button>

                <button class="splide__arrow--next w-11 h-11 flex justify-center items-center bg-primary hover:bg-primary-tone rounded-full">
                    <svg class="relative -right-px" width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.22748 8.80219L2.37798 15.6517C1.94989 16.1155 1.20072 16.1155 0.772631 15.6517C0.308863 15.2236 0.308863 14.4744 0.772631 14.0463L6.80162 7.98167L0.772631 1.95269C0.308863 1.5246 0.308863 0.775431 0.772631 0.347338C1.20072 -0.11643 1.94989 -0.11643 2.37798 0.347338L9.22748 7.19684C9.69125 7.62493 9.69125 8.37409 9.22748 8.80219Z" fill="#3B3C4A"/>
                    </svg>
                </button>
              </div>
            </div>
      </Splide>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import { Splide, SplideTrack, SplideSlide } from '@splidejs/vue-splide';

export default defineComponent({
  components: {
    Splide,
    SplideTrack,
    SplideSlide,
  },
  props: {
    name: {
      type: String,
      default: "reviews_gallery",
    }
  },
  data() {
    return {
      currentSlideIndex: 0,
      options: {
        pagination: false,
        arrows: true,
        type : 'loop',
        perMove: 1,
        breakpoints: {
          768: {
            pagination: true,
          },
        },
      },
    }
  },
  computed: {
    gallery() {
      return window?.capes?.[this.name] ?? {}
    },
    currentCaption() {
      if (!this.gallery || this.gallery.length === 0) {
        return null;
      }
      const currentItem = this.gallery[this.currentSlideIndex];
      return currentItem && currentItem.alt ? currentItem.alt : null;
    }
  },
  methods: {
    onSlideChange(splide, newIndex) {
      this.currentSlideIndex = newIndex;
    }
  },
});
</script>